<script setup lang="ts">
import { computed } from "vue"
import { GDialog } from 'gitart-vue-dialog'

type Props = {
  modelValue: boolean,
  title?: string,
  titleClass?: string,
  modalMaxWidth?: string,
  contentClass?: string,
  width?: string,
};

const props = withDefaults(defineProps<Props>(), {
  title: "",
  titleClass: 'confirmation-modal-title',
  contentClass: 'confirmation-modal-note',
  width: '50%'
});

const emit = defineEmits(['update:modelValue'])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})
</script>

<template>
  <GDialog
    v-model="modelValue"
    :max-width="props.modalMaxWidth"
    transition="custom-from-bottom-transition"
    :persistent='true'
    :width="props.width"
  >
    <slot name="flash-message" />
    <div
      class="modal-header justify-content-center mt-2">
      <label :class="props.titleClass">{{ title }}</label>
    </div>

    <div class="modal-body mx-4">
      <div :class="props.contentClass">
        <slot name="content" />
      </div>
    </div>

    <div
      class="d-flex justify-content-end m-3 mt-4"
    >
      <slot name="buttons" />
    </div>
  </GDialog>
</template>
<style scoped>
:deep(.g-dialog-content) {
  min-width: 550px !important;
}
</style>
